import React from 'react';

const OpportunityLayout = ({ 
  children, 
  sidebarRef, 
  isSidebarOpen, 
  setIsSidebarOpen, 
  filtersContent 
}) => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Mobile Overlay */}
      {isSidebarOpen && (
        <div 
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-30"
          onClick={() => setIsSidebarOpen(false)}
        />
      )}

      {/* Mobile Filters Sidebar */}
      <aside
        ref={sidebarRef}
        className={`lg:hidden fixed top-20 left-0 w-80 bg-white border-r border-gray-200 
                  shadow-xl z-40 transform transition-transform duration-300 ease-out
                  ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'}`}
        style={{ 
          height: 'calc(100vh - 5rem)',
          maxHeight: 'calc(100vh - 5rem)'
        }}
      >
        {filtersContent}
      </aside>

      {/* Desktop Layout */}
      <div className="hidden lg:flex relative">
        {/* Desktop Filters Sidebar */}
        <aside
          className="sticky top-20 w-80 bg-white border-r border-gray-200 
                    flex-shrink-0 h-[calc(100vh-5rem)] overflow-y-auto"
        >
          {filtersContent}
        </aside>

        {/* Desktop Main Content Area */}
        <main className="flex-1 bg-gray-50">
          {children}
        </main>
      </div>

      {/* Mobile Main Content Area */}
      <main className="lg:hidden bg-gray-50 w-full">
        {children}
      </main>
    </div>
  );
};

export default OpportunityLayout; 